/* =================== ANIMATE SCROLL =================== */

// Inicializa as animações de scroll
function initAnimations() {
  document.addEventListener("DOMContentLoaded", () => {
    // Offset padrão (threshold)
    const thresholdDefault = 25;
    // Resgata os elementos com base no atributo "data-aos"
    const animatedElements = document.querySelectorAll("[data-aos]");
    animatedElements.forEach((element) => {
      // Obtém o delay do elemento (Se houver)
      const delay = parseInt(element.getAttribute("data-aos-delay")) || 0;
      // Obtém o offset (threshold) do elemento (Se houver)
      /* O valor deve ser entre 0 e 100 
      (0 será animado mais rápido e 
      100 só será animado após todo o elemento aparecer) */
      let threshold =
        element.getAttribute("data-aos-offset") !== null
          ? parseInt(element.getAttribute("data-aos-offset"))
          : thresholdDefault;
      if (threshold > 100) threshold = 100;
      if (threshold < 0) threshold = 0;
      threshold = threshold / 100;
      // Verifica se o elemento está dentro de um carrossel no mobile
      let isInsideCarousel = element.closest(".splide__slide") !== null;
      if (isInsideCarousel && isMedia("mobile")) {
        threshold = 0;
      }
      onElementVisible(
        element,
        () => {
          setTimeout(() => {
            const animationClass = element.getAttribute("data-aos");
            element.classList.add(animationClass, "animated");
          }, delay + 200);
        },
        true,
        threshold
      );
    });
  });
}
initAnimations();

// Executa uma ação (callback) quando um elemento estiver visível na tela
function onElementVisible(
  element,
  callback,
  observeOnce = true,
  threshold = 0.5
) {
  element = element instanceof jQuery ? element[0] : element;
  if (!element || typeof callback !== "function") return;
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          callback();
          if (observeOnce) observer.disconnect();
        }
      });
    },
    {
      threshold: threshold,
    }
  );
  observer.observe(element);
}

// Verifica se um elemento está completamente visível na tela no momento da chamada
function isElementVisible(element) {
  element = element instanceof jQuery ? element[0] : element;
  if (!element) return false;
  const rect = element.getBoundingClientRect();
  return rect.top >= 0 && rect.bottom <= window.innerHeight;
}

// Dynamic scroll-drawn left border animation
function initScrollLines() {
  const elements = document.querySelectorAll(
    '.pag-sobre-texto, .editorial-texto > p:first-of-type, .editorial-lead, .sobre-quote-ong, blockquote'
  );
  if (elements.length === 0) return;

  const thresholds = Array.from({ length: 101 }, (_, i) => i / 100);
  const observer = new IntersectionObserver(
    (entries) => {
      const viewHeight = window.innerHeight;
      entries.forEach((entry) => {
        const el = entry.target;
        const rect = el.getBoundingClientRect();
        const start = viewHeight * 0.95;
        const end = viewHeight * 0.2;
        let pct = (start - rect.top) / (start - end);
        pct = Math.max(0, Math.min(1, pct));
        el.style.setProperty('--scroll-pct', pct.toFixed(3));
      });
    },
    {
      threshold: thresholds,
    }
  );

  elements.forEach((el) => observer.observe(el));

  function updateScrollLines() {
    const viewHeight = window.innerHeight;
    elements.forEach((el) => {
      const rect = el.getBoundingClientRect();
      const start = viewHeight * 0.95;
      const end = viewHeight * 0.2;
      let pct = (start - rect.top) / (start - end);
      pct = Math.max(0, Math.min(1, pct));
      el.style.setProperty('--scroll-pct', pct.toFixed(3));
    });
  }

  window.addEventListener('scroll', updateScrollLines, { passive: true });
  window.addEventListener('resize', updateScrollLines);
  updateScrollLines();
  setTimeout(updateScrollLines, 100);
}
document.addEventListener("DOMContentLoaded", initScrollLines);
